import { render, staticRenderFns } from "./policy-recom.vue?vue&type=template&id=0667d193&scoped=true&"
import script from "./policy-recom.vue?vue&type=script&lang=js&"
export * from "./policy-recom.vue?vue&type=script&lang=js&"
import style0 from "./policy-recom.vue?vue&type=style&index=0&id=0667d193&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0667d193",
  null
  
)

export default component.exports